import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Handles scroll behavior on route changes:
 * - If URL has a hash, smoothly scroll to that element (offset for fixed navbar).
 * - Otherwise, jump to the top of the page.
 */
const NAV_OFFSET = 80;

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait a tick so the target section is mounted.
      const id = hash.replace("#", "");
      const scroll = () => {
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;
          window.scrollTo({ top: y, behavior: "smooth" });
        } else {
          window.scrollTo({ top: 0, left: 0 });
        }
      };
      // Two RAFs to allow route content to render.
      requestAnimationFrame(() => requestAnimationFrame(scroll));
      return;
    }
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
